






















import Vue from 'vue';
import Component from 'vue-class-component';
import { mdiCheck } from '@mdi/js';
import { ValidationRule } from '@cnamts/vue-dot/src/rules/types';
import { requiredFn } from '@cnamts/vue-dot/src/rules/required';
import { Refs } from '@/types';

const Props = Vue.extend({
	props: {
		isNonRGFrancais: {
			type: Boolean,
			default: false
		},
		isChecked: {
			type: Boolean,
			default: false
		}
	}
});

@Component({
	model: {
		prop: 'isNonRGFrancais',
		event: 'change'
	}
})
export default class NonRGFrancais extends Props {

	$refs!: Refs<{
		nonRGFrancaisForm: HTMLFormElement;
	}>;

	checkIcon = mdiCheck;
	nonRGFrancaisLabel = 'Mon patient atteste ne pas appartenir au régime d’assurance maladie français.';

	nonRGFrancaisRules: ValidationRule[] = [
		requiredFn({ default: 'Ce champ est obligatoire.' })
	];

	get computedIsNonRGFrancais() {
		return this.isNonRGFrancais;
	}

	set computedIsNonRGFrancais(isNonRGFrancais) {
		this.$emit('change', isNonRGFrancais);
	}

	async validerNonRGFrancais(): Promise<boolean> {
		await this.$nextTick();
		return this.$refs.nonRGFrancaisForm.validate();
	}

	reset() {
		this.$refs.nonRGFrancaisForm.reset();
	}
}
